import { atom } from 'jotai'
import { focusAtom } from 'jotai-optics'
import { atomWithListeners, LifecycleState, PersistenceState } from '../../utilities'
import { ConformedCampaignLandingPage, MediaAsset } from '../../views'

export const [landingPageAtom, useLandingPageListener] = atomWithListeners<ConformedCampaignLandingPage | undefined>(
	undefined,
)

export const landingPageStatusAtom = atom<LifecycleState>('idle')
export const landingPageSavingAtom = atom<PersistenceState>('idle')

export const landingPageImageHistoryAtom = atom<Array<MediaAsset>>([])
export const landingPageHasGeneratedContentAtom = atom(false)

export const landingPageTitleAtom = focusAtom(landingPageAtom, (optic) => optic.optional().prop('title'))
export const landingPageSubtitleAtom = focusAtom(landingPageAtom, (optic) => optic.optional().prop('subtitle'))
export const landingPageBodyAtom = focusAtom(landingPageAtom, (optic) => optic.optional().prop('body'))
export const landingPageImageIdAtom = focusAtom(landingPageAtom, (optic) => optic.optional().prop('imageId'))

export const landingPageMetaAtom = focusAtom(landingPageAtom, (optic) => optic.optional().prop('meta'))
export const landingPageMetaReachOverrideUrlAtom = focusAtom(
	landingPageMetaAtom,
	(optic) => optic.optional().prop('reachOverrideUrl'),
)
export const landingPageMetaReachOverrideEnabledAtom = focusAtom(
	landingPageMetaAtom,
	(optic) => optic.optional().prop('reachOverrideEnabled'),
)
export const landingPageMetaLogoBackgroundFillColorAtom = focusAtom(
	landingPageMetaAtom,
	(optic) => optic.optional().prop('logoBackgroundFillColor'),
)
export const landingPageMetaShowLogoAtom = focusAtom(
	landingPageMetaAtom,
	(optic) => optic.optional().prop('showLogo'),
)
export const landingPageMetaForceAiGeneratedLabelAtom = focusAtom(
	landingPageMetaAtom,
	(optic) => optic.optional().prop('forceAiGeneratedLabel'),
)
export const landingPageMetaImageScaleAtom = focusAtom(
	landingPageMetaAtom,
	(optic) => optic.optional().prop('imageScale'),
)
export const landingPageMetaImageOffsetXAtom = focusAtom(
	landingPageMetaAtom,
	(optic) => optic.optional().prop('imageOffsetX'),
)
export const landingPageMetaImageOffsetYAtom = focusAtom(
	landingPageMetaAtom,
	(optic) => optic.optional().prop('imageOffsetY'),
)
